var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header colorHeader"},[_c('h2',{style:([
      !_vm.hasToken
        ? { right: '50px' }
        : _vm.isMobile
        ? { right: '30px' }
        : { right: '330px' },
    ]),attrs:{"id":"title"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"buttons"},[_c('app-select-role'),(!_vm.isMobile && _vm.currentBranch && _vm.isAdmin)?_c('v-btn',{staticClass:"admin-button",attrs:{"color":"cyan white--text","rounded":""},on:{"click":_vm.removeCurrentBranch}},[_vm._v(" بازگشت به منوی اصلی ")]):_vm._e(),(_vm.isMobile)?_c('v-btn',{staticClass:"home-button",attrs:{"color":"cyan white--text","rounded":""},on:{"click":_vm.goToIndex}},[_c('font-awesome-icon',{attrs:{"icon":"home","size":"lg"}})],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }